var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-navigation-drawer',{staticClass:"PluginPublishFlowDrawer",class:{
      settingsSidebar: true,
      isMobile: this.$vuetify.breakpoint.smAndDown,
    },attrs:{"input-value":_vm.drawer,"fixed":"","persistent":_vm.drawer,"height":"100%","bottom":_vm.isMobile,"right":!_vm.isMobile,"width":_vm.widthDimensions},on:{"input":_vm.onDrawerChange,"click":function($event){$event.stopPropagation();}},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('PluginPublishFlowPanel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }